
export enum tabEnum {
    invitationPrize = 'invitationPrize',
    dataStatistics = 'dataStatistics',
    InternalStaffStatistics = "InternalStaffStatistics",
    UserIntegralManager = 'UserIntegralManager',
}